module.exports = __webpack_public_path__ + "img/LicensesAndActivationsTableGenerateActivation.30e447f3.png";